"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _dropdown = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/dropdowns/dropdown"));

var _inputErrorWrapper = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/inputs/input-error-wrapper"));

var _styledText = _interopRequireDefault(require("@zipwhip/zipkit/dist/components/styled-text"));

var _textFormField = _interopRequireDefault(require("../text-form-field"));

var _constants = require("../../constants");

require("./address-form.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var STYLE_BASE = 'address-form_';
/*
    Zuora Billing Form takes in form data based off the of names of the fields when using this address form as the billing address for the credit card
    you need to update the names of the fields so Zuora knows the fields are for Payment
    Fields needing to be updated if addres form changes: 
        - Address 1
        - Address 2
        - City
        - Postal Code
    The dropdowns for Country and State will be handle in the hidden inputs in the Billing Form
*/

var AddressForm = function AddressForm(_ref) {
  var errors = _ref.errors,
      handleChange = _ref.handleChange,
      _ref$isPaymentAddress = _ref.isPaymentAddress,
      isPaymentAddress = _ref$isPaymentAddress === void 0 ? false : _ref$isPaymentAddress,
      setFieldTouched = _ref.setFieldTouched,
      setFieldValue = _ref.setFieldValue,
      _ref$touched = _ref.touched,
      touched = _ref$touched === void 0 ? {} : _ref$touched,
      values = _ref.values; // should this component take in names props? will change if needed

  var address1 = isPaymentAddress ? _constants.BILLING_ADDRESS_1 : _constants.ACCOUNT_ADDRESS_1;
  var address2 = isPaymentAddress ? _constants.BILLING_ADDRESS_2 : _constants.ACCOUNT_ADDRESS_2;
  var city = isPaymentAddress ? _constants.BILLING_CITY : _constants.ACCOUNT_CITY;
  var country = isPaymentAddress ? _constants.BILLING_COUNTRY : _constants.ACCOUNT_COUNTRY;
  var postalCode = isPaymentAddress ? _constants.BILLING_POSTAL_CODE : _constants.ACCOUNT_POSTAL_CODE;
  var state = isPaymentAddress ? _constants.BILLING_STATE : _constants.ACCOUNT_STATE;
  var isUS = values[country] === 'US';
  return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_textFormField.default, {
    error: errors[_constants.ACCOUNT_ADDRESS_1],
    label: "Business Street Address",
    name: address1,
    onChange: handleChange,
    pattern: "[A-Za-z0-9\\s.\\-,#]+",
    placeholder: "Address Line 1",
    testid: "ADDRESS_FORM_ADDRESS_LINE_1",
    touched: touched[_constants.ACCOUNT_ADDRESS_1],
    value: values[address1]
  }), _react.default.createElement(_textFormField.default, {
    error: errors[_constants.ACCOUNT_ADDRESS_2],
    name: address2,
    onChange: handleChange,
    pattern: "[A-Za-z0-9\\-.,\\s#]+",
    placeholder: "Address Line 2 (optional)",
    required: false,
    testid: "ADDRESS_FORM_ADDRESS_LINE_2",
    touched: touched[_constants.ACCOUNT_ADDRESS_2],
    value: values[address2]
  }), _react.default.createElement(_textFormField.default, {
    error: errors[_constants.ACCOUNT_CITY],
    label: "City",
    name: city,
    onChange: handleChange,
    pattern: "[a-zA-Z\\s]+",
    placeholder: "City",
    testid: "ADDRESS_FORM_CITY",
    touched: touched[_constants.ACCOUNT_CITY],
    value: values[city]
  }), _react.default.createElement(_styledText.default, {
    className: "".concat(STYLE_BASE, "inputLabel")
  }, "Country"), _react.default.createElement(_formik.Field, {
    autoComplete: "creditCardCountry",
    className: "".concat(STYLE_BASE, "country"),
    component: _dropdown.default,
    items: _constants.COUNTRY_VALUES,
    name: country,
    onBlur: setFieldTouched,
    onChange: function onChange(value) {
      setFieldValue(country, value);
      setFieldValue(_constants.ACCOUNT_POSTAL_CODE, '');
      setFieldValue(_constants.ACCOUNT_STATE, '');
    },
    placeholder: "Country",
    searchable: true,
    testid: "ADDRESS_FORM_COUNTRY",
    selectedValue: values[country]
  }), _react.default.createElement("div", {
    className: "".concat(STYLE_BASE, "stateZipSection")
  }, _react.default.createElement("div", null, _react.default.createElement(_styledText.default, {
    className: "".concat(STYLE_BASE, "inputLabel")
  }, isUS ? 'State' : 'Province'), _react.default.createElement(_inputErrorWrapper.default, {
    containerClassName: "".concat(STYLE_BASE, "postalInputsContainer"),
    error: errors[state] && touched[state] ? errors[state] : null
  }, _react.default.createElement(_formik.Field, {
    autoComplete: "field_creditCardState",
    className: "".concat(STYLE_BASE, "postalInputs"),
    component: _dropdown.default,
    errors: errors[state],
    items: isUS ? _constants.US_STATES : _constants.CANADIAN_PROVINCES,
    name: state,
    onBlur: function onBlur() {
      setFieldTouched(state);
    },
    onChange: function onChange(value) {
      setFieldValue(state, value);
    },
    placeholder: isUS ? 'State' : 'Province',
    searchable: true,
    testid: "ADDRESS_FORM_STATE",
    touched: touched[state],
    selectedValue: values[state]
  }))), _react.default.createElement("div", {
    className: "".concat(STYLE_BASE, "postalInputsContainer")
  }, _react.default.createElement(_textFormField.default, {
    className: "".concat(STYLE_BASE, "postalInputs"),
    containerClassName: "".concat(STYLE_BASE, "postalInputsContainer "),
    error: errors[_constants.ACCOUNT_POSTAL_CODE],
    label: "Postal Code",
    name: postalCode,
    onChange: handleChange,
    pattern: "\\d*",
    placeholder: "Zipcode",
    testid: "ADDRESS_FORM_ZIPCODE",
    touched: touched[_constants.ACCOUNT_POSTAL_CODE],
    value: values[postalCode]
  }))));
};

var _default = AddressForm;
exports.default = _default;